import React from 'react';
import PropTypes from 'prop-types';

import Image from 'common/components/Placeholder/components/Image/Image';
import TextBlock from 'common/components/Placeholder/components/TextBlock/TextBlock';

import styles from './ArticleSmall.module.scss';

const ArticleSmall = (props) => (
  <div className={`${props.className} ${styles.ArticleSmall}`}>
    <Image
      color={styles.PlaceholderDefaultColor}
      className={styles.ImageSmall}
    />
    <div className={styles.WhiteBox}>
      <TextBlock
        rows={3}
        color={styles.PlaceholderDefaultColor}
        className={styles.TextBlock}
      />
    </div>
  </div>
);

ArticleSmall.propTypes = {
  className: PropTypes.string
}

ArticleSmall.defaultProps = {
  className: ''
}

export default ArticleSmall;



// WEBPACK FOOTER //
// ./src/common/components/Placeholder/components/ArticleSmall/ArticleSmall.js